import script from "./ToUp.vue?vue&type=script&setup=true&lang=js"
export * from "./ToUp.vue?vue&type=script&setup=true&lang=js"

import "./ToUp.vue?vue&type=style&index=0&id=33002b04&lang=css"

const __exports__ = script;

export default __exports__